import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';

const routes: Routes = [
  {
    path: 'adesao/:contractToken',
    loadChildren: () => import('./accession/accession.module').then( m => m.AccessionPageModule)
  },
  {
    path: 'invoice/:invoiceToken',
    loadChildren: () => import('./invoice/invoice.module').then( m => m.InvoicePageModule)
  },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, { preloadingStrategy: PreloadAllModules })
  ],
  exports: [RouterModule]
})
export class AppRoutingModule { }
